import { otelSchema } from './otel/otel.schema';

export const observabilitySchema = otelSchema.transform((otel) => ({
  observability: otel,
}));
